import { useState, useEffect } from "react";
import { Loader2, CheckCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { LOADING_DURATIONS } from "@/config/loadingDurations";

interface LoadingItem {
  id: number;
  text: string;
  completed: boolean;
}

export function LoadingWizardSession() {
  const [loadingItems, setLoadingItems] = useState<LoadingItem[]>([
    {
      id: 1,
      text: "Preluăm automat datele publice ale companiei.",
      completed: false,
    },
    {
      id: 2,
      text: "Vei putea verifica și corecta informațiile conform aplicabilițătii NIS2",
      completed: false,
    },
    {
      id: 3,
      text: "La final primești formularul de notificare precompletat corespunzător",
      completed: false,
    },
  ]);

  useEffect(() => {
    const intervals: NodeJS.Timeout[] = [];
    const customDelays = LOADING_DURATIONS.wizardInit;

    loadingItems.forEach((item, index) => {
      const timeout = setTimeout(() => {
        setLoadingItems((prev) =>
          prev.map((prevItem) =>
            prevItem.id === item.id
              ? { ...prevItem, completed: true }
              : prevItem
          )
        );
      }, customDelays[index]);

      intervals.push(timeout);
    });

    return () => {
      intervals.forEach(clearTimeout);
    };
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center space-y-6 max-w-2xl mx-auto px-4">
        <div className="space-y-4">
          <Loader2 className="h-8 w-8 animate-spin mx-auto text-primary" />
          <div className="space-y-2">
            <h3 className="text-lg font-heading font-semibold">
              Pregătim evaluarea companiei tale conform NIS2
            </h3>
            <p className="text-muted-foreground">
              În câțiva pași simpli, te ajutăm cu notificarea pentru DNSC.
            </p>
          </div>
        </div>

        <Card className="bg-muted/30 text-left">
          <CardContent className="pt-6">
            <ul className="space-y-3">
              {loadingItems.map((item) => (
                <li
                  key={item.id}
                  className={`flex items-center gap-3 transition-all duration-4000 ${
                    item.completed ? "animate-fade-in" : "opacity-50"
                  }`}
                >
                  <div className="flex-shrink-0">
                    {item.completed ? (
                      <CheckCircle className="w-4 h-4 text-ds-green-600 animate-scale-in" />
                    ) : (
                      <div className="w-4 h-4 rounded-full bg-primary" />
                    )}
                  </div>
                  <span
                    className={`text-sm ${
                      item.completed
                        ? "text-foreground"
                        : "text-muted-foreground"
                    }`}
                  >
                    {item.text}
                  </span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
